import { useEffect } from 'react'

import { PackageOption } from './ESignatureMapping'
import { Checkbox } from '@/components/CheckboxV2'
import { ProfileTypes } from '@/constants/applicationProfile'
import { ESignatureSelect } from '@/features/SidePanel/CustomerMessages/steps/ESignatureSelect'
import { ApplicationProfile } from '@/types/unlock'

const getLabel = (position: number, profileType: string) => {
  if (position === 1) return 'Applicant'
  if (profileType === ProfileTypes.APPLICANT) return 'Co-Applicant'
  if (profileType === ProfileTypes.CO_OWNER) return 'Co-Owner'
  if (profileType === ProfileTypes.NOO) return 'NOO'
}

const firstLetter = (s: string) => s.charAt(0)

type Props = {
  applicant: ApplicationProfile
  availableOptions: PackageOption[]
  checkboxes: boolean[]
  defaultPackageValue: string
  dispatch: React.Dispatch<any>
  handleCheckboxChange: (idx: number) => void
  idx: number
  recipientsOptions: ApplicationProfile[]
  selectedRecipients: ApplicationProfile[]
}

export function ESignatureRecipient({
  applicant,
  availableOptions,
  checkboxes,
  defaultPackageValue,
  dispatch,
  handleCheckboxChange,
  idx,
  recipientsOptions,
  selectedRecipients,
}: Props) {
  const recipientSelected = (applicationProfile: ApplicationProfile) =>
    selectedRecipients.some((recipient) => applicationProfile?.id === recipient?.id)
  useEffect(() => {
    if (availableOptions?.length === 0 && applicant?.id)
      dispatch({
        type: 'setESignatures',
        payload: {
          action: 'remove',
          applicationProfileId: applicant.id,
        },
      })
  }, [availableOptions?.length])
  if (availableOptions?.length === 0) return null
  return (
    <div
      className={idx === recipientsOptions.length - 1 ? '' : 'mb-6'}
      key={idx}
    >
      <div className='mb-2'>
        <label>
          {getLabel(applicant?.position, applicant?.profile_type)} - {applicant.profile.first_name}{' '}
          {firstLetter(applicant.profile.last_name)}
        </label>
        <div className='flex flex-row items-center'>
          <input
            className='classic-input mr-2'
            type='text'
            value={applicant?.profile?.email}
            disabled
          />
          <Checkbox
            checked={checkboxes[idx]}
            onChange={handleCheckboxChange(idx)}
          />
        </div>
      </div>
      <ESignatureSelect
        dispatch={dispatch}
        applicantProfile={applicant}
        applicantNotSelected={!recipientSelected(applicant)}
        defaultPackageValue={defaultPackageValue}
        availableOptions={availableOptions}
      />
    </div>
  )
}
